import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
/* Return true if props does not change */
const memoOnlyForKeys = (keys: string[]): any => (
  prev: any,
  next: any,
): boolean => {
  /* Return true if key is not equal, then some is break and return true */
  const equal = keys.every(key => {
    if (get(prev, key) === get(next, key)) return true;
    return isEqual(get(prev, key), get(next, key));
  });
  return equal;
};

export default memoOnlyForKeys;
